const emailTriggerTypes = {
  COUNT_COMPLETED: 'COUNT_COMPLETED',
  CASE_UPDATED: 'CASE_UPDATED',
  USAGE_SUBMITTED: 'USAGE_SUBMITTED',
  CASE_BOOKED: 'CASE_BOOKED',
  CASES_BACKUP: 'CASES_BACKUP'
};

export default emailTriggerTypes;
